
import commonApi from "@/apis/common.api";
import { $_DKD } from "@/confs/common.const.js";

export default {
    state: {
        videoInfo: {},
    },
    getters: {
        getVideoInfo(state) {
            return state.videoInfo;
        },
    },
    mutations: {
        VIDEO_INFO(state, videoInfo) {
            state.videoInfo = videoInfo;
        },
    },
    actions : {
        FETCH_VIDEO_INFO({commit}) {
            commonApi.fetchMaxBasdtValDataList($_DKD.INTRO_VIDEO)
                .then((res)=>{
                    if(res.data.data.length > 0){
                        commit('VIDEO_INFO', res.data.data[0]);
                    }
                });
        },
    }
};
